import { render, staticRenderFns } from "./FixedDeskEmployeesPage.vue?vue&type=template&id=97de5b68&"
import script from "./FixedDeskEmployeesPage.vue?vue&type=script&lang=js&"
export * from "./FixedDeskEmployeesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports